import { createAction } from "redux-actions";
import { GENERATE_CHECKBOOK, GET_CHECKBOOK, GET_CHECKBOOK_CHARGE, GET_CHECKBOOK_ENDORSMENT } from "../constants";
import { serverGetCheckbook } from "./../services/checkbooks";
import { urlCheckbooks } from "./../services/urls";
import { feathersCreateData } from "../services";


/* export const generateCheckbook = createAction(GENERATE_CHECKBOOK, (cedule, amount, date, serie, imei, emited, emitidor, email, description) => 
    serverCreateCheckbook(urlUserCheckbooks, cedule, amount, date, serie, imei, emited, emitidor, email, description)()) */

export const generateCheckbook = createAction(GENERATE_CHECKBOOK, (data) => feathersCreateData('user-checkbooks', data)())

export const getCheckbook = createAction(GET_CHECKBOOK, (field, charge) => 
    serverGetCheckbook(urlCheckbooks, field, charge)())

/* export const getCheckbookCharge = createAction(GET_CHECKBOOK_CHARGE, (field, charge) => 
    serverGetCheckbook(urlCheckbooks, field, charge)()) */



/* export const getCheckCharge = createAction(GET_CHECKBOOK, (cedule, amount, date, serie, imei, emited, emite, email, description) => 
    serverGetCheckCharge(urlUserCheckbooks, cedule, amount, date, serie, imei, emited, emite, email, description)()) */

export const getCheckCharge = createAction(GET_CHECKBOOK_CHARGE, (mobile,cedule, amount, date, emited, charge, email, description) => 
    feathersCreateData('user-checkbooks', { mobile, cedule, amount, date, emited, charge, email, description })())

/* export const setEndorse = createAction(GET_CHECKBOOK, (cedule, amount, date, serie, imei, emited, emite, email, description, image) => 
    serverSetEndorse(urlUserCheckbooks, cedule, amount, date, serie, imei, emited, emite, email, description, image)()) */


    export const setEndorse = createAction(GET_CHECKBOOK_ENDORSMENT, (mobile, cedule, amount, date, emited, charge, email, description, code) => 
        feathersCreateData('user-checkbooks',{ mobile, cedule, amount, date, emited, charge, email, description, code })())